export function buildConfirmBody(idempotencyKey, booking, gateway, payment) {
  const body = {
    idempotency_key: idempotencyKey,
    ...booking,
  };

  if (!payment) {
    return body;
  }

  body.gateway_name = payment.gateway_name || gateway?.gateway_name;
  body.gateway_auth_intent_id = payment.gateway_auth_intent_id;
  body.gateway_payment_intent_id = payment.gateway_payment_intent_id;

  if (payment.gateway_name === "razorpay" && payment.razorpay_signature) {
    body.razorpay_signature = payment.razorpay_signature;
  }

  return body;
}
